import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function AdminBookings() {
    const [items, setItems] = useState([]);
    useEffect(() => { api.get("/admin/bookings").then((r) => setItems(r.data)).catch(() => {}); }, []);
    return (
        <div data-testid="admin-bookings-page">
            <div className="label-tag">Bookings</div>
            <h1 className="mt-3 font-display text-4xl font-bold">Consultation requests</h1>
            <div className="mt-8 bg-ink-900 border border-white/10 rounded-2xl overflow-x-auto">
                <table className="w-full text-sm min-w-[800px]">
                    <thead className="bg-ink-800 text-xs uppercase tracking-[0.2em] text-white/50">
                        <tr>
                            <th className="text-left px-5 py-4">Name</th>
                            <th className="text-left px-5 py-4">Email</th>
                            <th className="text-left px-5 py-4">Union</th>
                            <th className="text-left px-5 py-4">Service</th>
                            <th className="text-left px-5 py-4">Date</th>
                            <th className="text-left px-5 py-4">Time</th>
                            <th className="text-left px-5 py-4">Submitted</th>
                        </tr>
                    </thead>
                    <tbody>
                        {items.length === 0 ? (
                            <tr><td colSpan={7} className="text-center text-white/50 py-10">No bookings yet.</td></tr>
                        ) : items.map((b) => (
                            <tr key={b.id} className="border-t border-white/10" data-testid={`admin-booking-${b.id}`}>
                                <td className="px-5 py-4">{b.name}</td>
                                <td className="px-5 py-4 text-white/70">{b.email}</td>
                                <td className="px-5 py-4 text-white/70">{b.union_name || "—"}</td>
                                <td className="px-5 py-4 text-white/60">{b.service_slug}</td>
                                <td className="px-5 py-4">{b.preferred_date}</td>
                                <td className="px-5 py-4">{b.preferred_time}</td>
                                <td className="px-5 py-4 text-white/50">{new Date(b.created_at).toLocaleDateString()}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
